import { useEffect } from 'react';

export const HowItWorksSchema = () => {
  useEffect(() => {
    const howItWorksStructuredData = {
      "@context": "https://schema.org",
      "@type": "HowTo",
      "name": "How to Hire a Tradesman on Sortable",
      "description": "Step-by-step guide to hiring verified local tradesmen with fast response guarantee",
      "image": "https://sortable.lovable.app/assets/hero-tradesman.jpg",
      "totalTime": "PT15M",
      "estimatedCost": {
        "@type": "MonetaryAmount",
        "currency": "GBP",
        "value": "0"
      },
      "supply": [
        {
          "@type": "HowToSupply",
          "name": "Job Description"
        },
        {
          "@type": "HowToSupply", 
          "name": "Location"
        },
        {
          "@type": "HowToSupply",
          "name": "Contact Details"
        }
      ],
      "step": [
        {
          "@type": "HowToStep",
          "position": 1,
          "name": "Post Your Job",
          "text": "Describe your job requirements, location, and preferred timing. It's completely free to post.",
          "image": "https://sortable.lovable.app/assets/hero-tradesman.jpg"
        },
        {
          "@type": "HowToStep", 
          "position": 2,
          "name": "Receive Responses",
          "text": "Get fast responses from verified local tradesmen. All tradesmen are vetted and insured.",
          "image": "https://sortable.lovable.app/assets/hero-tradesman.jpg"
        },
        {
          "@type": "HowToStep",
          "position": 3,
          "name": "Choose Your Tradesman",
          "text": "Review profiles, ratings, and quotes. Contact your chosen tradesman directly to arrange the work.",
          "image": "https://sortable.lovable.app/assets/hero-tradesman.jpg"
        }
      ]
    };

    const scriptId = 'how-it-works-structured-data';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = scriptId;
      document.head.appendChild(script);
    }
    
    script.textContent = JSON.stringify(howItWorksStructuredData);

    return () => {
      const script = document.getElementById(scriptId);
      if (script) {
        script.remove();
      }
    };
  }, []);

  return null;
};